/*eslint-disable*/

import {
  Flex,
  Link,
  List,
  ListItem,
  Text,
  useColorModeValue,
} from '@chakra-ui/react';

export default function Footer() {
  const textColor = useColorModeValue('gray.400', 'white');
  return (
    <Flex
      zIndex="3"
      flexDirection={{
        base: 'column',
        xl: 'row',
      }}
      alignItems={{
        base: 'center',
        xl: 'start',
      }}
      justifyContent="space-between"
      px={{ base: '30px', md: '50px' }}
      pb="30px"
    >
      <Text
        color={textColor}
        textAlign={{
          base: 'center',
          xl: 'start',
        }}
        mb={{ base: '20px', xl: '0px' }}
      >
        {' '}
        &copy; {new Date().getFullYear()}
        <Text as="span" fontWeight="500" ms="4px">
          {/* <Link href="https://www.simmmple.com/" target="_blank">
            Simmmple
          </Link> */}
          {/* {' - Coded by '} */}
          {/* <Link href="https://appseed.us/" target="_blank"> */}
          ATLANTIS
          {/* </Link> */}
        </Text>
      </Text>
      <List display="flex">
        <ListItem
          me={{
            base: '20px',
            md: '44px',
          }}
        >
          {/* <Link
            fontWeight="500"
            color={textColor}
            target="_blank"
            href="https://appseed.us/support/"
          >
            Support
          </Link> */}
        </ListItem>
        <ListItem
          me={{
            base: '20px',
            md: '44px',
          }}
        >
          {/* <Link
            fontWeight="500"
            color={textColor}
            target="_blank"
            href="https://appseed.us/product/horizon-ui-pro/full-stack/"
          >
            Product
          </Link> */}
        </ListItem>
        <ListItem
          me={{
            base: '20px',
            md: '44px',
          }}
        >
          {/* <Link
            fontWeight="500"
            color={textColor}
            target="_blank"
            href="https://appseed.us/product/horizon-ui/api-server-nodejs/"
          >
            Free Version
          </Link> */}
        </ListItem>
      </List>
    </Flex>
  );
}
